"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LobbyViewMusicWrapper;

var _react = _interopRequireWildcard(require("react"));

var _LobbyViewModule = _interopRequireDefault(require("./LobbyView.module.scss"));

var _BackgroundMusic = _interopRequireDefault(require("../../environment/BackgroundMusic/BackgroundMusic"));

var _CreateMode = _interopRequireDefault(require("./components/CreateMode/CreateMode"));

var _SelectMode = _interopRequireDefault(require("./components/SelectMode/SelectMode"));

var _SelectedMode = _interopRequireDefault(require("./components/SelectedMode/SelectedMode"));

var _ = require("../../..");

var _environment = require("../../environment");

var _assets = require("../../../assets");

var _inputElements = require("../../inputElements");

var _Modal = _interopRequireDefault(require("../../common/Modal/Modal"));

var _PromptWindow = _interopRequireDefault(require("../../windows/other/PromptWindow/PromptWindow"));

var _openFullscreen = _interopRequireDefault(require("../../../helpers/fullscreen/openFullscreen"));

var _closeFullscreen = _interopRequireDefault(require("../../../helpers/fullscreen/closeFullscreen"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function LobbyView(_ref) {
  var onExit = _ref.onExit;

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      styleSelectMode = _useState2[0],
      setStyleSelectMode = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = _slicedToArray(_useState3, 2),
      styleSelectedMode = _useState4[0],
      setStyleSelectedMode = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = _slicedToArray(_useState5, 2),
      styleCreateMode = _useState6[0],
      setStyleCreateMode = _useState6[1];

  var _useState7 = (0, _react.useState)({}),
      _useState8 = _slicedToArray(_useState7, 2),
      styleSpinner = _useState8[0],
      setStyleSpinner = _useState8[1];

  var _useState9 = (0, _react.useState)(true),
      _useState10 = _slicedToArray(_useState9, 2),
      isSelectModeVisible = _useState10[0],
      setIsSelectModeVisible = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isSelectedModeVisible = _useState12[0],
      setIsSelectedModeVisible = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      isCreateModeVisible = _useState14[0],
      setIsCreateModeVisible = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      isSpinnerVisible = _useState16[0],
      setIsSpinnerVisible = _useState16[1]; // eslint-disable-next-line @typescript-eslint/no-unused-vars


  var fromSelectToSelected = (0, _react.useCallback)(function () {
    setStyleSelectMode({
      transition: "1s",
      opacity: 0
    });
    setStyleSelectedMode({
      display: "block",
      opacity: 0
    });
    setIsSelectedModeVisible(true);
    setTimeout(function () {
      setStyleSelectedMode({
        display: "block",
        transition: "1s",
        opacity: 1
      });
    }, 1000);
    setTimeout(function () {
      setStyleSelectMode({
        display: "none"
      });
      setIsSelectModeVisible(false);
    }, 1000);
  }, []);
  var fromSelectToCreate = (0, _react.useCallback)(function () {
    setStyleSelectMode({
      transition: "1s",
      opacity: 0
    });
    setStyleCreateMode({
      display: "block",
      opacity: 0
    });
    setIsCreateModeVisible(true);
    setTimeout(function () {
      setStyleCreateMode({
        display: "block",
        transition: "1s",
        opacity: 1
      });
    }, 1000);
    setTimeout(function () {
      setStyleSelectMode({
        display: "none"
      });
      setIsSelectModeVisible(false);
    }, 2000);
  }, []);
  var fromCreateCancelToSelect = (0, _react.useCallback)(function () {
    setStyleCreateMode({
      display: "block",
      transition: "1s",
      opacity: 0
    });
    setStyleSelectMode({
      display: "block",
      opacity: 0
    });
    setIsSelectModeVisible(true);
    setTimeout(function () {
      setStyleSelectMode({
        display: "block",
        transition: "1s",
        opacity: 1
      });
    }, 1000);
    setTimeout(function () {
      setStyleCreateMode({
        display: "none"
      });
      setIsCreateModeVisible(false);
    }, 2000);
  }, []);
  var fromCreateSubmitToSelect = (0, _react.useCallback)(function () {
    // TODO: create the character, show it within seats
    fromCreateCancelToSelect();
  }, [fromCreateCancelToSelect]);
  var fromSelectedCancelToSelect = (0, _react.useCallback)(function () {
    setStyleSelectedMode({
      display: "block",
      transition: "1s",
      opacity: 0
    });
    setStyleSelectMode({
      display: "block",
      opacity: 0
    });
    setIsSelectModeVisible(true);
    setTimeout(function () {
      setStyleSelectMode({
        display: "block",
        transition: "1s",
        opacity: 1
      });
    }, 1000);
    setTimeout(function () {
      setStyleSelectedMode({
        display: "none"
      });
      setIsSelectedModeVisible(false);
    }, 2000);
  }, []);
  var fromSelectedSubmitToEnterGame = (0, _react.useCallback)(function () {
    console.error("TODO: NYI");
    setStyleSelectedMode({
      display: "block",
      transition: "1s",
      opacity: 0
    });
    setStyleSpinner({
      display: "block",
      opacity: 0
    });
    setIsSpinnerVisible(true);
    setTimeout(function () {
      setStyleSpinner({
        transition: "1s",
        opacity: 1
      });
    }, 1000);
    setTimeout(function () {
      window.location.replace("/iframe.html?id=views-ingameview--default");
    }, 4000);
  }, []);

  var modalContentFullscreen = /*#__PURE__*/_react.default.createElement(_PromptWindow.default, {
    onSubmit: function onSubmit() {
      (0, _openFullscreen.default)().catch(function (error) {
        return console.error(error);
      }); // eslint-disable-next-line @typescript-eslint/no-use-before-define

      setModalContent(undefined);
    } // eslint-disable-next-line @typescript-eslint/no-use-before-define
    ,
    onCancel: function onCancel() {
      return setModalContent(undefined);
    }
  }, "Open Fullscreen ? ");

  var modalContentExit = /*#__PURE__*/_react.default.createElement(_PromptWindow.default, {
    onSubmit: function onSubmit() {
      (0, _closeFullscreen.default)().catch(function (error) {
        return console.error(error);
      });
      if (onExit) onExit(); // eslint-disable-next-line @typescript-eslint/no-use-before-define

      setModalContent(undefined);
    } // eslint-disable-next-line @typescript-eslint/no-use-before-define
    ,
    onCancel: function onCancel() {
      return setModalContent(undefined);
    }
  }, "Exit FHX ? ");

  var _useState17 = (0, _react.useState)(modalContentFullscreen),
      _useState18 = _slicedToArray(_useState17, 2),
      modalContent = _useState18[0],
      setModalContent = _useState18[1];

  return /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbyViewModule.default.lobbyView
  }, modalContent && /*#__PURE__*/_react.default.createElement(_Modal.default, null, modalContent), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.LOBBY_EXIT,
    className: _LobbyViewModule.default.exitBtn,
    onClick: function onClick() {
      return setModalContent(modalContentExit);
    }
  }), isSelectModeVisible && /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbyViewModule.default.selectMode,
    style: styleSelectMode
  }, /*#__PURE__*/_react.default.createElement(_SelectMode.default, {
    onSelectExistingCharacter: fromSelectToSelected,
    onCreateNewCharacter: fromSelectToCreate
  })), isSelectedModeVisible && /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbyViewModule.default.selectedMode,
    style: styleSelectedMode
  }, /*#__PURE__*/_react.default.createElement(_SelectedMode.default, {
    onSubmit: fromSelectedSubmitToEnterGame,
    onCancel: fromSelectedCancelToSelect
  })), isCreateModeVisible && /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbyViewModule.default.createMode,
    style: styleCreateMode
  }, /*#__PURE__*/_react.default.createElement(_CreateMode.default, {
    onSubmit: fromCreateSubmitToSelect,
    onCancel: fromCreateCancelToSelect
  })), isSpinnerVisible && /*#__PURE__*/_react.default.createElement("div", {
    className: _LobbyViewModule.default.spinnerWrapper,
    style: styleSpinner
  }, /*#__PURE__*/_react.default.createElement(_.Spinner, {
    imageFile: "".concat(_assets.ASSETS_EFFECTS, "/MSquare14.gif"),
    duration: 2,
    width: 200,
    text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Loading. Please wait..."),
    className: _LobbyViewModule.default.spinner
  })));
}

function LobbyViewMusicWrapper() {
  // Note: This is required because the inner LobbyView changes it's state during transitions and would restart the audio track
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_BackgroundMusic.default, {
    song: _environment.EBackgroundMusicSong.LOBBY,
    volume: 100,
    withRandomGap: false
  }), /*#__PURE__*/_react.default.createElement(LobbyView, null));
}